const highlights = [
  { icon: 'ri-shield-check-line', text: '所有代理產品通過 ATEX、IECEx、CE 國際認證' },
  { icon: 'ri-global-line', text: '與歐美原廠直接合作，供貨穩定、交期準確' },
  { icon: 'ri-customer-service-2-line', text: '專業工程顧問團隊，全程技術諮詢與售後服務' },
  { icon: 'ri-settings-3-line', text: '客製化設備配置，滿足各類嚴苛工況需求' },
];

const stats = [
  { num: '40+', label: '年產業經驗' },
  { num: '50+', label: '合作品牌' },
  { num: '1000+', label: '服務客戶' },
];

export default function HomeAbout() {
  return (
    <section className="w-full bg-[#1a2535] py-16 px-4">
      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row gap-12 items-stretch">

        {/* Left: Image with stats overlay */}
        <div className="relative w-full lg:w-[400px] flex-shrink-0 min-h-[300px]">
          <img
            src="/images/17131727573736.jpg"
            alt="益維企業"
            className="w-full h-full object-cover object-top"
          />
          {/* Blue overlay */}
          <div className="absolute inset-0 bg-[#1a73b5]/60" />
          {/* Decorative border */}
          <div className="absolute inset-3 border border-white/20" />

          {/* Stats overlay */}
          <div className="absolute bottom-0 left-0 right-0 flex">
            {stats.map((s, i) => (
              <div
                key={s.label}
                className={`flex-1 flex flex-col items-center justify-center py-4 bg-[#1a2535]/80
                  ${i < stats.length - 1 ? 'border-r border-white/10' : ''}`}
              >
                <span className="text-2xl font-bold text-[#4fc3f7]">{s.num}</span>
                <span className="text-xs text-white/60 mt-0.5 whitespace-nowrap">{s.label}</span>
              </div>
            ))}
          </div>

          {/* Label tag */}
          <div className="absolute top-5 left-0 bg-[#1a73b5] px-4 py-1.5">
            <span className="text-white text-xs font-bold tracking-widest uppercase">Since 2000</span>
          </div>
        </div>

        {/* Right: Text content */}
        <div className="flex-1 flex flex-col justify-center">
          {/* Section title */}
          <p className="text-xs tracking-[0.35em] text-[#4fc3f7] uppercase mb-3">ABOUT US</p>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-1 h-8 bg-[#1a73b5]" />
            <h2 className="text-2xl md:text-3xl font-bold text-white tracking-wider">關於益維企業</h2>
          </div>

          <p className="text-sm text-gray-300 leading-[2] mb-6">
            益維企業有限公司（Electronics World Co., Ltd）成立於台灣台北，長期專注於歐美工業控制系統的代理與銷售，致力於為台灣各大製造業、石化、電力及工程產業提供高品質的工業自動化設備與解決方案。
          </p>

          {/* Highlights */}
          <ul className="flex flex-col gap-3 mb-8">
            {highlights.map(h => (
              <li key={h.text} className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${h.icon} text-[#4fc3f7] text-base`} />
                </div>
                <span className="text-sm text-gray-300 leading-relaxed">{h.text}</span>
              </li>
            ))}
          </ul>

          {/* Divider */}
          <div className="flex items-center gap-3 mb-7">
            <div className="h-px flex-1 bg-white/10" />
          </div>

          {/* CTA */}
          <div className="flex flex-wrap gap-3">
            <a
              href="/about"
              className="inline-flex items-center gap-2 bg-[#1a73b5] text-white text-sm font-semibold px-6 py-2.5 hover:bg-[#1558a0] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-information-line" />
              了解更多
            </a>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 border border-white/20 text-white/80 text-sm px-6 py-2.5 hover:bg-white/10 hover:border-white/40 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              立即洽詢
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
